const adminDomainRegex = /^(admin|editor)\..*/; // Starts with 'admin.' or 'editor.'

export function isEditor() {
	return adminDomainRegex.test(window.location.hostname);
}

export function isAdmin() {
	return isEditor() || (window.location.hostname === 'localhost');
}

export function isLocalhostEvent() {
	return window.location.hostname === 'localhost' && window.location.pathname.startsWith('/event');
}

export function isEvent() {
	return !isAdmin() || isLocalhostEvent();
}

export default { isAdmin, isEditor, isLocalhost: isLocalhostEvent };
